// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TransferWindowDrawer_wrapper__ojEGF","open":"TransferWindowDrawer_open__SNS7n"};